module.exports = require("./ff-Adlm-LR.d.ts");